// import AllTips from "./AllTips";
// import RTVTipsters from "./RTVTipsters";
// import Tipster from "./RTVTipsters";
// import IndividualTipster from "./IndividualTipster";
// import NapOfTheDay from "./NapOfTheDay";

// lazyImport the above imports

import lazyImport from "../../../utils/lazyImport/lazyImport";

const AllTips = lazyImport(() => import("./AllTips"));
const RTVTipsters = lazyImport(() => import("./RTVTipsters"));
const Tipster = lazyImport(() => import("./RTVTipsters"));
const IndividualTipster = lazyImport(() => import("./IndividualTipster"));
const NapOfTheDay = lazyImport(() => import("./NapOfTheDay"));

export default {
  AllTips,
  RTVTipsters,
  Tipster,
  IndividualTipster,
  NapOfTheDay,
};
